module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Home/Commode#1-15c8a9041c83cc279cb89ab58d680c73.svg";